import { AfterViewInit, Component, DestroyRef, Input, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DocumentLibrary } from '@apps/documents/document.state';
import { NavigationService } from '@platform/shared/navigation.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-document-widget-table',
  templateUrl: './document-widget-table.component.html',
  styleUrls: ['./document-widget-table.component.scss'],
  standalone: false,
})
export class DocumentWidgetTableComponent implements AfterViewInit {
  @ViewChild(MatTable) table!: MatTable<DocumentLibrary>;
  @Input() documentLibraries: Observable<DocumentLibrary[]>;
  @Input() customerSpaceId: string;
  @Input() displayRowsCount = 6;
  dataSource = new MatTableDataSource<DocumentLibrary>([]);

  /** Columns displayed in the table. */
  displayedColumns = ['title', 'status'];

  public navigation = inject(NavigationService);

  private destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    this.documentLibraries.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource = new MatTableDataSource(data.slice(0, this.displayRowsCount));
      this.table.dataSource = this.dataSource;
    });
  }

  onRowClick(event: Event, row: DocumentLibrary) {
    event.preventDefault();
    this.navigation.navigateToDocuments(row, this.customerSpaceId);
  }
}
